import store from '../vuex'

const isAuthRoute = route => route.path.indexOf('/auth') !== -1
const isAdminRoute = route => route.path.indexOf('/auth_admin') !== -1
const isSignupRoute = route => route.path.indexOf('/signup') !== -1
const isSubscribe = route => route.path.indexOf('/subscribe') !== -1
const isPayment = route => route.path.indexOf('/payment') !== -1
const isRegisterNewPassword = route => route.path.indexOf('/new_password') !== -1
const isRecoverPassword = route => route.path.indexOf('/recover_password') !== -1
const isAuthenticated = () => store.getters.isLogged
const isRouteWithAuthentication = to => !(isAuthRoute(to) || isAdminRoute(to) || isSignupRoute(to) || isRegisterNewPassword(to) || isRecoverPassword(to) ||
 isSubscribe(to) || isPayment(to))

export default (to, from, next) => {
  window.scrollTo(0, 0)
  store.commit('prevRoute', from)
  store.commit('setCurrentRoute', to.path)
  document.documentElement.classList.remove('ls-sidebar-visible')

  if (isAuthenticated()) {
    next()
    return
  } else {
    if (isRouteWithAuthentication(to)) {
      next('/auth')
      return
    } else {
      next()
      return
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/beforeEach.js